import { useCallback, useState } from 'react';
import { getDashboardAggregate, getQuestGenerationStatus } from '../api/dataService';

export const useDashboardData = () => {
  const [aggregate, setAggregate] = useState(null);
  const [generationStatus, setGenerationStatus] = useState({ state: 'idle', job: null });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [aggregateRes, statusRes] = await Promise.allSettled([
        getDashboardAggregate(),
        getQuestGenerationStatus(),
      ]);

      if (statusRes.status === 'fulfilled') {
        const statusData = statusRes.value?.data || null;
        if (statusData) {
          setGenerationStatus(statusData);
        }
      }

      if (aggregateRes.status !== 'fulfilled') {
        throw aggregateRes.reason || new Error('Failed to fetch dashboard aggregate.');
      }

      setAggregate(aggregateRes.value?.data || null);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    aggregate,
    generationStatus,
    refreshData,
    isLoading,
    error,
  };
};

